// redux
/* eslint-disable no-shadow */
import React, { lazy, useEffect, useState } from 'react';
// import API from '@aws-amplify/api';
import { FaDiscord } from 'react-icons/fa';
import classNames from 'classnames';
import styled from 'styled-components';
import { Link } from 'react-router-dom';
import { connect } from 'react-redux';

import { updateSubscription } from '../app/actions';
import { permissionsStatuses } from '../util/constants';
import { Button } from '../components/Button';
import { ElementLoading } from '../components/ElementLoading';
import { Title } from '../components/Title';
import { ContentScreen } from '../styles/ContentScreen';

const Subscribe = lazy(() => import('../exercises/Subscribe'));

const Subscription = ({ subscriptionData, onCancel }) => {
   const [apiRequestSent, setApiRequestSent] = useState(false);

   if (subscriptionData.loading) {
      return <ElementLoading />;
   }

   if (
      subscriptionData.status === 'active' &&
      new Date(subscriptionData.expiration) > Date.now()
   ) {
      return (
         <div>
            <p>
               Type:{' '}
               <strong>
                  {subscriptionData.frequency === 'month'
                     ? 'Monthly'
                     : 'Yearly'}{' '}
                  Subscription
               </strong>
            </p>
            <p>
               Next Payment:{' '}
               {subscriptionData.autoPayCancelled ? (
                  <span>
                     <strong>None</strong>
                  </span>
               ) : (
                  <span>
                     <strong>${subscriptionData.price}</strong> on{' '}
                     <strong>
                        {new Date(
                           new Date(subscriptionData.expiration) -
                              2 * 24 * 60 * 60 * 1000
                        ).toLocaleDateString()}
                     </strong>
                  </span>
               )}
            </p>
            {subscriptionData.autoPayCancelled ? (
               <p>
                  You can resubscribe after your current subscription expires on{' '}
                  {new Date(subscriptionData.expiration).toLocaleDateString()}
               </p>
            ) : (
               <Button
                  type="button"
                  className={classNames('button-dismiss', {
                     'button-loading': apiRequestSent,
                  })}
                  style={{ padding: 0 }}
                  disabled={apiRequestSent}
                  onClick={() => {
                     const cancel = confirm(
                        'Are you sure you want to unsubscribe from Ear Instructor?\n\nYour Discord roles will be removed immediately if you have connected your Discord account.'
                     );

                     if (cancel) {
                        setApiRequestSent(true);
                        // API.post('app', '/purchase/cancel-subscription')
                        //    .then(onCancel)
                        //    .catch(() => {
                        //       alert('An error occurred. Please try Again');
                        //       setApiRequestSent(false);
                        //    });
                     }
                  }}
               >
                  Cancel Subscription
               </Button>
            )}
         </div>
      );
   }
   return (
      <div>
         <p>You do not have an active subscription</p>
         <Button className="button-cta" as={Link} to="/app/account/subscribe">
            Subscribe Now
         </Button>
      </div>
   );
};

const SubscribeScreen = ({ isNotSubscribed, updateSubscription, plans }) => {
   if (!isNotSubscribed) {
      // success screen here?

      return (
         <ContentScreen className="narrower">
            <article>
               <h1>Success!</h1>
               <p>
                  A subscription has been added to your account. Thank you for
                  your support!
               </p>
               <div style={{ textAlign: 'center' }}>
                  <Button className="button-cta" as={Link} to="/app/account">
                     Back to Account
                  </Button>
               </div>
            </article>
         </ContentScreen>
      );
   }

   return (
      <ContentScreen className="narrower">
         <Subscribe
            plans={plans}
            onSubscribe={(token) => updateSubscription(token)}
         />
      </ContentScreen>
   );
};

const mapStateToProps = ({ appData: { permissions } }) => {
   const subData = permissions?.subscriptionAndPurchases?.subscription;

   let isNotSubscribed = true;

   if (permissions.status === permissionsStatuses.loaded && subData) {
      if (
         new Date(subData.expiration) > Date.now() &&
         subData.includes.includes('exercise')
      ) {
         isNotSubscribed = false;
      }
   }

   return {
      isNotSubscribed,
   };
};

const mapDispatchToProps = { updateSubscription };

const Account = connect(
   mapStateToProps,
   mapDispatchToProps
)(({ isNotSubscribed, updateSubscription }) => {
   const [subscriptionData, setSubscriptionData] = useState({ loading: true });

   useEffect(() => {
      // API.get('app', '/purchase/subscription').then(({ subscription }) =>
      //    setSubscriptionData(subscription || {})
      // );
   }, [isNotSubscribed]);

   return (
      <>
         <Title title="Account Settings" />
         <ContentScreen className="narrower">
            <article>
               <h1>Account</h1>
               <h2>Subscription</h2>
               <Subscription
                  subscriptionData={subscriptionData}
                  onCancel={() => {
                     setSubscriptionData((subData) => ({
                        ...subData,
                        autoPayCancelled: true,
                     }));
                  }}
               />
               <Link to="/app/discord">
                  <FaDiscord />
               </Link>
            </article>
         </ContentScreen>
      </>
   );
});

const AccountSubscribe = connect(
   mapStateToProps,
   mapDispatchToProps
)(({ isNotSubscribed, updateSubscription }) => {
   const [plans, setPlans] = useState(null);

   useEffect(() => {
      // API.get('app', '/purchase/plans').then(setPlans);
   }, []);

   return (
      <>
         <Title title="Subscribe" />
         <SubscribeScreen
            plans={plans}
            isNotSubscribed={isNotSubscribed}
            updateSubscription={updateSubscription}
         />
      </>
   );
});

export { Account, AccountSubscribe };
